export default __webpack_public_path__ + "static/media/value3.56ca1628.png";